(function () {
  'use strict';

  var STORAGE_KEY = 'cc_recently_viewed';
  var STORAGE_VERSION = 1;

  function readStore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return { v: STORAGE_VERSION, items: [] };
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.v !== STORAGE_VERSION || !Array.isArray(parsed.items)) {
        return { v: STORAGE_VERSION, items: [] };
      }
      return parsed;
    } catch (e) {
      return { v: STORAGE_VERSION, items: [] };
    }
  }

  function formatMoney(cents, format) {
    var amount = (cents / 100);
    var formatted = amount.toLocaleString('es-CO', { maximumFractionDigits: 0 });
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, formatted);
    }
    return '$' + formatted;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function renderCardMinimal(item, imageSize) {
    var w = imageSize || 150;
    var img = item.image
      ? '<img src="' + item.image + '" class="cc-recent__img" loading="lazy" decoding="async" width="' + w + '" height="' + w + '" alt="" aria-hidden="true">'
      : '<div class="cc-recent__img cc-recent__img--empty"></div>';
    return ''
      + '<div class="cc-recent__item" role="listitem">'
      +   '<a class="cc-recent__card cc-recent__card--minimal" href="' + item.url + '" aria-label="' + escapeHtml(item.title) + '">'
      +     '<div class="cc-recent__media">' + img + '</div>'
      +   '</a>'
      + '</div>';
  }

  function renderCardFull(item, showCompare) {
    var hasCompare = showCompare && item.compare_at_price && Number(item.compare_at_price) > Number(item.price);
    var fmt = item.money_format || '';
    var priceHtml = hasCompare
      ? '<span class="cc-recent__price-compare">' + formatMoney(item.compare_at_price, fmt) + '</span>'
        + '<span class="cc-recent__price cc-recent__price--sale">' + formatMoney(item.price, fmt) + '</span>'
      : '<span class="cc-recent__price">' + formatMoney(item.price, fmt) + '</span>';

    var img = item.image
      ? '<img class="cc-recent__img" src="' + item.image + '" alt="" loading="lazy" decoding="async">'
      : '<div class="cc-recent__img cc-recent__img--empty"></div>';

    return ''
      + '<div class="cc-recent__item" role="listitem">'
      +   '<a class="cc-recent__card cc-recent__card--full" href="' + item.url + '">'
      +     '<div class="cc-recent__media">' + img + '</div>'
      +     '<div class="cc-recent__body">'
      +       '<div class="cc-recent__title">' + escapeHtml(item.title) + '</div>'
      +       '<div class="cc-recent__price-row">' + priceHtml + '</div>'
      +     '</div>'
      +   '</a>'
      + '</div>';
  }

  function updateArrowVisibility(section) {
    var track = section.querySelector('[data-cc-recent-track]');
    var prev = section.querySelector('[data-cc-recent-prev]');
    var next = section.querySelector('[data-cc-recent-next]');
    if (!track || (!prev && !next)) return;
    var hasOverflow = track.scrollWidth > track.clientWidth + 4;
    if (!hasOverflow) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }
    if (prev) prev.hidden = track.scrollLeft <= 4;
    if (next) next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  }

  function bindArrows(section) {
    var track = section.querySelector('[data-cc-recent-track]');
    var prev = section.querySelector('[data-cc-recent-prev]');
    var next = section.querySelector('[data-cc-recent-next]');
    if (!track) return;
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left:  track.clientWidth * 0.8, behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { updateArrowVisibility(section); }, { passive: true });
    window.addEventListener('resize', function () { updateArrowVisibility(section); }, { passive: true });
    requestAnimationFrame(function () { updateArrowVisibility(section); });
  }

  function renderSection(section) {
    var max = parseInt(section.dataset.maxItems, 10) || 12;
    var min = parseInt(section.dataset.minItems, 10) || 2;
    var excludeCurrent = section.dataset.excludeCurrent === '1';
    var currentId = parseInt(section.dataset.currentId, 10) || null;
    var showCompare = section.dataset.showCompare === '1';
    var cardStyle = section.dataset.cardStyle || 'minimal';
    var imageSize = parseInt(section.dataset.imageSize, 10) || 150;

    var store = readStore();
    var items = store.items.slice();
    if (excludeCurrent && currentId) {
      items = items.filter(function (it) { return it.id !== currentId; });
    }
    items = items.slice(0, max);
    if (items.length < min) return;

    var track = section.querySelector('[data-cc-recent-track]');
    if (!track) return;
    track.innerHTML = items.map(function (it) {
      return (cardStyle === 'full') ? renderCardFull(it, showCompare) : renderCardMinimal(it, imageSize);
    }).join('');
    section.hidden = false;
    bindArrows(section);
  }

  function init() {
    // Tracking vive en snippets/cc-recently-viewed-tracker.liquid (cargado en layout/theme.liquid).
    // Esta IIFE solo se encarga de renderizar el carrusel desde lo que el snippet ya escribió en localStorage.
    var sections = document.querySelectorAll('[data-cc-recent]');
    for (var i = 0; i < sections.length; i++) renderSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
